import React from "react";

export default function SEO() {
  return (
    <div className="page">
      <h1>SEO & Online Visibility</h1>
      <p>SEO services placeholder.</p>
    </div>
  );
}
